import { axiosInstance, handleAxiosResponse } from "../../../core/sources/network";
import { appLocalStorage, lskeys } from "../../../core/sources/local-storage";

import { handleError } from "../../app-messages";
import { actions as mainProfileActions } from "../../main-profile/slice";
import { actions as companyProfileActions } from "../../company-profile/slice";
import { actions } from "../slice";

export const signIn = ({ email, password, unblacklist }) => {
  return async (dispatch) => {
    try {
      const response = await axiosInstance.post("/authentication/sign-in", {
        email,
        password,
        unblacklist,
      });

      const { data } = handleAxiosResponse(response);

      const { companyProfile, recruiterProfile } = data;

      appLocalStorage.save({
        ...(companyProfile && { [lskeys.companyProfile]: companyProfile }),
        [lskeys.recruiterProfile]: recruiterProfile,
      });

      if (companyProfile) {
        dispatch(companyProfileActions.setProfile({ profile: companyProfile }));
      }

      dispatch(mainProfileActions.setProfile({ profile: recruiterProfile }));
      dispatch(actions.login());

      return { verified: recruiterProfile.verified };
    } catch (error) {
      if (error?.response?.data?.message === "your account is blacklisted") {
        return error?.response?.data?.message;
      }

      handleError(error?.response?.data?.message ?? error.message)(dispatch);
    }
  };
};
